module.exports = __webpack_public_path__ + "static/assets/e9c0499c4fd9f4cd80b965208249e800.svg";